module.exports = __webpack_public_path__ + "img/pumpjack-base.0860dc4f.png";